import * as React from "react";
import type { SVGProps } from "react";

const SvgCircleShareIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
        <g
            id="Group_10077"
            data-name="Group 10077"
            transform="translate(0.299)"
        >
            <circle
                id="Ellipse_420"
                data-name="Ellipse 420"
                cx="16"
                cy="16"
                r="16"
                transform="translate(-0.299)"
                fill="currentColor"
            />
            <g
                id="Group_10833"
                data-name="Group 10833"
                transform="translate(6.701 7)"
            >
                <g
                    id="Group_6967"
                    data-name="Group 6967"
                    transform="translate(0 0)"
                >
                    <path
                        id="Union_56"
                        data-name="Union 56"
                        d="M0,17.292l.181-.6c.559-1.861,1.092-3.336,3.058-3.9l.289-.082,1.463.428,1.463-.428.289.082c1.966.56,2.5,2.034,3.057,3.9l.181.6Zm1.38-.948H8.6c-.546-1.177-.58-2.107-1.869-2.554l-1.742.691L3.249,13.79C1.96,14.237,1.927,15.166,1.38,16.344Zm.588-6.637A2.938,2.938,0,0,1,4.99,6.861,2.938,2.938,0,0,1,8.012,9.706,2.937,2.937,0,0,1,4.99,12.551,2.937,2.937,0,0,1,1.968,9.706Zm1.007,0A1.958,1.958,0,0,0,4.99,11.6a1.958,1.958,0,0,0,2.015-1.9A1.958,1.958,0,0,0,4.99,7.81,1.958,1.958,0,0,0,2.976,9.706Zm6.044,2.371.181-.6c.559-1.861,1.091-3.336,3.057-3.9l.289-.082,1.463.429L15.472,7.5l.289.082c1.966.559,2.5,2.034,3.058,3.9l.181.6Zm1.38-.948H17.62c-.546-1.177-.58-2.107-1.869-2.554l-1.742.691-1.742-.691C10.979,9.022,10.946,9.951,10.4,11.129Zm.588-6.638A2.937,2.937,0,0,1,14.01,1.646a2.937,2.937,0,0,1,3.022,2.844A2.938,2.938,0,0,1,14.01,7.336,2.937,2.937,0,0,1,10.988,4.491Zm1.007,0a2.018,2.018,0,0,0,4.03,0,2.018,2.018,0,0,0-4.03,0ZM.5,6.594A5.316,5.316,0,0,1,.7,5.045C1.564,2.012,4.243.789,7.468,1.6A6.412,6.412,0,0,1,8.6,2L8.127.619a.468.468,0,0,1,.324-.6.514.514,0,0,1,.636.3l1.033,3L6.932,4.3A.508.508,0,0,1,6.3,4a.471.471,0,0,1,.322-.6l1.553-.473-.707-.339c-.087-.026-.173-.051-.259-.073-2.687-.678-4.814.245-5.534,2.774A4.472,4.472,0,0,0,1.5,6.582a.49.49,0,0,1-.5.48H1A.487.487,0,0,1,.5,6.594Z"
                        transform="translate(0 0)"
                        fill="#fff"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export default SvgCircleShareIcon;
